import Dummy from '../../utils/dummy';
import watchEverythingRequest from './request';
import { Observable } from 'rxjs';

const WAITING_TIME = 100;

function watchEverythingObservable(channelName: string) {
  return new Observable((subscriber) => {
    subscriber.next(Dummy.getPhoto().data);
    watchEverythingRequest(channelName).then((data) => {
      setTimeout(() => {
        subscriber.next(data);
        subscriber.complete();
      }, WAITING_TIME);
    });
  });
}

export default watchEverythingObservable;
